export class Raster {
    constructor(bounds, fill = null) {
        this.bounds = bounds;
        this.size = { x: bounds.botright.x - bounds.topleft.x + 1, y: bounds.topleft.y - bounds.botright.y + 1 };
        this.data = new Array(this.size.x * this.size.y);
        if (fill)
            this.data = this.data.map(() => fill());
    }
    xyToI(tile) {
        // TODO: Simplify origin?
        return (tile.y - this.bounds.botright.y) * this.size.x + (tile.x - this.bounds.topleft.x);
    }
    iToXY(i) {
        return {
            x: i % this.size.x + this.bounds.topleft.x,
            y: Math.floor(i / this.size.x) + this.bounds.botright.y
        };
    }
    get(tile) {
        return this.data[this.xyToI(tile)];
    }
    set(tile, value) {
        this.data[this.xyToI(tile)] = value;
    }
}
